module.exports = __webpack_public_path__ + "dist/assets/940b035ec7f717755aadbf2f6729f704.svg";